import { ComplexCommission, ComplexCommissionTier, DefaultInput } from "@PayPlans/helpers/DefaultSections/Commons";

const flaggedHoursBonusDefault = () => {
	const max = 9999999;
	const maxDuration = 744;
	const commission = ComplexCommission([maxDuration, "Duration"], [0, "Duration"], {
		identifier: "commission",
		commission: [0, "Percent"],
	});
	return {
		tiers: [ComplexCommissionTier([0, "Unit"], [max, "Unit"], { commissions: [commission] })],
		applyTiersRetroactively: false,
	};
};

const holidayPayDefault = () => {
	return {
		holidaysSelected: [],
		holidayByType: "By PTO Modality",
	};
};

const nightShiftPayDefault = () => ({
	from: null,
	to: null,
	commission: DefaultInput(0, "Percent"),
	prorateByTimeCard: true,
	isMultipleDays: false,
	daysSelected: [],
	offset: 0,
});

const targetedPerformanceBonusDefault = () => {
	const max = 9999999;
	const maxDuration = 744;
	const commission = ComplexCommission([maxDuration, "Duration"], [0, "Duration"], {
		identifier: "commission",
		commission: [0, "Percent"],
	});
	return {
		tiers: [ComplexCommissionTier([0, "Unit"], [max, "Unit"], { commissions: [commission] })],
		applyTiersRetroactively: false,
	};
};

export {
	flaggedHoursBonusDefault as FlaggedHoursBonusDefault,
	holidayPayDefault as HolidayPayDefault,
	nightShiftPayDefault as NightShiftPayDefault,
	targetedPerformanceBonusDefault as TargetedPerformanceBonusDefault,
};
